import $ from 'jquery';

import Confirmer from './confirm';
import Error from './error';

class AddPayment {

	constructor() {
		
		if ($(".payment-form").length > 0) {
			this.init();
		}

	}

	init() {

		Vue.component("payment-selector", () => import("../components/PaymentForm"));


		this.data = window.paymentData;
		this.data.amount = 0;
		this.vmdata = { 
			payment : this.data,
			amount: 0
		};

		this.vm = new Vue({
			el: "#main_form",
			data: this.vmdata
		});

		
	    $("#amount").change(e => {
	    	let amnt = $(e.target).val();
	    	if (isNaN(amnt) || amnt < 0) {
	    		amnt = 0;
	    		$("#amount").val(0);
	    	}

	    	this.data.amount = amnt;
		    this.vmdata.amount = amnt;
		    
	    }).change();


	    $(".payment-form").submit(e => {
	    	$("#paymentdata").val(JSON.stringify(this.data));
	    });

	    $("#save-button").click(e => {
	    	e.preventDefault();
	    	if (this.validate()) {
	    		$(".payment-form").submit();
	    	}
	    });

	}

	validate() {
		let data = this.data;

		// do we have an amount?
		if ($("#amount").val() == 0 && (data.useprevious == false || (data.useprevious == true && data.previous == 0) )) {
			new Error("Error", "Please Enter an Amount");
			return false;
		}

		// Are any of the invoices selected?
		let any = false;
		data.invoices.forEach(invoice => {
			if (invoice.selected && invoice.used > 0) {
				any = true;
			}
		});

		if (any == false) {
			new Error("Error", "Please select an invoice to apply the payment to");
			return false;
		}
		
		if (data.balance < 0) {


			let message = "Processing this payment will leave an extra balance of " + 
				data.currency + 
				Math.abs(data.balance) + 
				" in the client's account";

			new Error("Cannot Create Receipt", message, true);
			return false;

		}


		return true
	}


}

export default AddPayment;
